// 리퍼럴 & 리워드 프로그램(#515 Phase 1, PR #520) 노출 여부.
// 백엔드 API(/referral/*, /reward/*)가 운영에 배포되기 전까지 운영 빌드에서 잠근다
// — .env.production=false, .env.development=true. 미설정 시 잠김(안전 기본값).
// 잠금 범위: /my/rewards 라우트·마이페이지 메뉴, ?ref= 어트리뷰션 캡처,
// 장바구니 추천코드 입력·자동 적용, 회원가입 referralCode 연결.
export const REFERRAL_REWARDS_ENABLED = process.env.REACT_APP_FEATURE_REFERRAL_REWARDS === 'true';

// Journey 단계 미리보기 바(임시 QA 도구, web#551) 노출 여부.
// dev 사이트에서 샘플 데이터로 ①~⑤ 단계를 확인하기 위한 것 —
// .env.development=true, .env.production=false. 미설정 시 잠김(안전 기본값).
// prod 출시 전 미리보기 바 자체를 제거하면 이 플래그도 함께 정리한다.
export const JOURNEY_STAGE_PREVIEW_ENABLED = process.env.REACT_APP_FEATURE_JOURNEY_STAGE_PREVIEW === 'true';
